import * as queryString from 'querystring';

/**
 * Builds a url from a route and query params
 * @param route The route of the url
 * @param params The query params to use
 * @returns The built url
 */
// Array values are serialised as repeated keys (`ids=a&ids=b`), which is what ASP.NET's
// `[FromQuery] List<T>` binds from.
export function buildUrl(route: string, params?: { [key: string]: string | string[] }) {
	if (params) {
		return `${route}?${queryString.stringify(params)}`;
	}

	return route;
}
